export type { InputProps } from '../Input/Input.types'
export { TextInput } from './TextInput'
